import { EchartLegendPosition } from '@nimbus-library/features/charts/models/echart/echart-legend-position.enum';

export interface EchartLegendOption {
  type: 'plain' | 'scroll';
  position: EchartLegendPosition;
  xPosition: string | number;
  yPosition: string | number;
  keepYPosition: boolean;
  padding: number[] | 0;
  itemWidth?: number;
  textWidth: number;
  textOverflow: 'break' | 'breakAll' | 'truncate' | 'none';
  fontSize: string | number;
  hideValue: boolean;
}

export const EchartLegendOptionDefault: EchartLegendOption = {
  type: 'plain',
  position: EchartLegendPosition.None,
  xPosition: undefined,
  yPosition: undefined,
  keepYPosition: false,
  padding: 0,
  itemWidth: undefined,
  textWidth: undefined,
  textOverflow: 'none',
  fontSize: undefined,
  hideValue: false,
};
